<script setup lang="ts">
import type { DisciplineScheduleGridSlot } from '../model/interfaces'

import { faCalendarCircleExclamation } from '@fortawesome/pro-regular-svg-icons'

import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'

import DisciplineScheduleSelector from './DisciplineScheduleSelector.vue'
import { useDisciplineScheduleSlot } from '../model/discipline-schedule-slot.hook'

defineOptions({
  name: 'DisciplineScheduleSlot',
})

const props = defineProps<{
  scheduleSlot: DisciplineScheduleGridSlot
}>()

const {
  refIsSelected,
  refIsDisabled,
  refIsPartlyBusy,
  refBusyNotes,
  busyText,
  toggleSlot,
} = useDisciplineScheduleSlot({
  slot: computed(() => props.scheduleSlot),
})
</script>

<template>
  <div
    v-if="refIsDisabled"
    class="discipline-schedule-slot"
  >
    <AppTooltip
      :text="busyText"
      size="small"
    >
      <DisciplineScheduleSelector
        :text="scheduleSlot.start_time"
        :unavailable="!scheduleSlot.in_schedule"
        disabled
      />
    </AppTooltip>
  </div>
  <DisciplineScheduleSelector
    v-else
    :text="scheduleSlot.start_time"
    :selected="refIsSelected"
    :unavailable="!scheduleSlot.in_schedule"
    class="discipline-schedule-slot"
    @click="toggleSlot"
  >
    <span
      v-if="refIsPartlyBusy"
      class="discipline-schedule-slot__busy"
    >
      <AppTooltip
        :text="refBusyNotes"
        size="small"
      >
        <AppIcon
          :icon="faCalendarCircleExclamation"
          size="small"
          color="amber-600"
        />
      </AppTooltip>
    </span>
  </DisciplineScheduleSelector>
</template>

<style scoped lang="scss" src="./DisciplineScheduleSlot.scss" />
